import { regEx } from '../../lib';

const getSingleGeometryType = geometryType =>
  regEx.multiGeometryType.test(geometryType)
    ? geometryType.split('Multi')[1]
    : geometryType;

export default getSingleGeometryType;
